module.exports = __webpack_public_path__ + "static/media/Sodexo.70be6abe.png";